'use client';

import { MotionProps, motion } from 'framer-motion';
import useMeasure from 'react-use-measure';
import {
  Box,
  BoxProps,
  Flex,
  forwardRef,
  useMergeRefs,
} from '@chakra-ui/react';

const ChakraMotionBox = motion.create(Box);

interface Props {
  containerProps?: BoxProps & MotionProps;
}

export const ResizablePanel = forwardRef<Props, 'div'>((props, ref) => {
  const { containerProps = {}, children, ...rest } = props;

  const [innerRef, { height }] = useMeasure();

  const mergedRefs = useMergeRefs(ref, innerRef);

  return (
    <ChakraMotionBox
      animate={{ height: height || 'auto' }}
      transition={{ duration: 0.1 }}
      w="full"
      {...containerProps}
    >
      <Flex ref={mergedRefs} w="full" {...rest}>
        {children}
      </Flex>
    </ChakraMotionBox>
  );
});
